import { useContext, useEffect } from "react";
import { useAtom, useSetAtom } from "jotai";
import { OnboardingService } from "services";
import {
	pasoActualAtom, statusOnboardingAtom,
	estadoFirmaOnboardingAtom, estadoHuellaOnboardingAtom,
	informacionPersonalCompletadoAtom
} from "pages/onboarding/OnboardingStore";
import { SecurityContext } from "context/SecurityContextProvider";

const useStatusOnboarding = () => {
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const isLaredo = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20132377783" ? true : false;

	const [statusOnboarding, setStatusOnboarding] = useAtom(statusOnboardingAtom);
	const setPasoActual = useSetAtom(pasoActualAtom);
	const [estadoFirma, setEstadoFirma] = useAtom(estadoFirmaOnboardingAtom);
	const [estadoHuella, setEstadoHuella] = useAtom(estadoHuellaOnboardingAtom);
	const [informacionPersonalCompletado, setInformacionPersonalCompletado] = useAtom(informacionPersonalCompletadoAtom);

	useEffect(() => {
		const cargarDatos = async () => {
			try {
				const statusOnboarding = await OnboardingService.obtenerStatusOnboarding();
				console.log("statusOnboarding", statusOnboarding);
				setStatusOnboarding(statusOnboarding);
				setPasoActual(statusOnboarding.etapa);
				setEstadoFirma(statusOnboarding.estadoImagenFirma);
				setEstadoHuella(statusOnboarding.estadoImagenHuella);
				setInformacionPersonalCompletado(statusOnboarding.informacionPersonalCompletado);
			} catch (e) {
				console.error("El colaborador no tiene el estado onboarding");
			}
		};
		cargarDatos();
	}, []);

	return { statusOnboarding };
};

export default useStatusOnboarding;
